export default __webpack_public_path__ + "static/media/SZ.cfe56315.txt";